import { createAction, props } from '@ngrx/store';

export const setLocation = createAction(
  '[Location] Set Location',
  props<{ latitude: number; longitude: number }>()
);

export const resetLocation = createAction(
  '[Location] Reset Location'
);